module.exports = __webpack_public_path__ + "img/before_lawn_treatment.e099090d.png";